import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Typography } from '@mui/material';
import axios from 'axios';

interface Klasifikasi {
  id: string;
  nama: string;
}

interface IndeterminateCheckboxProps {
  jenisPustakaSelected: { id: string; label: string };
  klasifikasiSelected: string[];
  setKlasifikasiSelected: React.Dispatch<React.SetStateAction<string[]>>;
  klasifikasiList: Klasifikasi[] | null;
  setKlasifikasiList: (value: Klasifikasi[] | null) => void;
}

const IndeterminateCheckbox: React.FC<IndeterminateCheckboxProps> = ({
  jenisPustakaSelected,
  klasifikasiSelected,
  setKlasifikasiSelected,
  klasifikasiList,
  setKlasifikasiList
}) => {
  const [checked, setChecked] = useState<{ [key: number]: boolean }>({});

  useEffect(() => {
    getChecked();
  }, [klasifikasiSelected]);

  useEffect(() => {
    if (jenisPustakaSelected) {
      getKlasifikasiKoleksi();
      setChecked({});
    }
  }, [jenisPustakaSelected]);

  const getKlasifikasiKoleksi = async () => {
    if (!jenisPustakaSelected) return;

    try {
      if (jenisPustakaSelected?.label !== 'Semua') {
        const response = await axios.get(
          `${process.env.NEXT_PUBLIC_API_URL}/klasifikasi?jenis-pustaka=${jenisPustakaSelected.label}`
        );
        setKlasifikasiList(response.data);
      } else {
        setKlasifikasiList([]);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  const handleChangeChild = (event: React.ChangeEvent<HTMLInputElement>, id: number) => {
    // setChecked({ ...checked, [id]: event.target.checked });
    if (event.target.checked) {
      setKlasifikasiSelected((prev: string[]) => {
        return [...prev, event.target.value];
      });
    } else {
      setKlasifikasiSelected((prev: string[]) => {
        return prev.filter((v) => v !== event.target.value);
      });
    }
  };

  const getChecked = () => {
    if (klasifikasiList && klasifikasiSelected.length) {
      klasifikasiSelected.forEach((item, key) => {
        handleToggleCheckbox(key, item !== '');
      });
    }
  };

  const handleToggleCheckbox = (id: number, state: boolean) => {
    setChecked((prev) => ({
      ...prev,
      [id]: state
    }));
  };

  return (
    <div>
      {jenisPustakaSelected && jenisPustakaSelected?.label !== 'Semua' && (
        <>
          <Typography>{jenisPustakaSelected.label}</Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', ml: 3 }}>
            {klasifikasiList &&
              klasifikasiList.map((item, key) => (
                <div key={key}>
                  <FormControlLabel
                    label={item.nama}
                    control={
                      <Checkbox
                        value={item.id}
                        // checked={checked[key] || false}
                        onChange={(e) => handleChangeChild(e, key)}
                      />
                    }
                  />
                </div>
              ))}
          </Box>
        </>
      )}
    </div>
  );
};

export default IndeterminateCheckbox;
